module.exports = __webpack_public_path__ + "img/QXB4x57kkr.b8959b6e.png";